<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dostawcy</span>
        <h3 class="page-title">Lista dostawców</h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="success"
          class="text-nowrap"
          @click.prevent="$router.push('/dostawcy/nowy')">
          <i class="material-icons">add</i>
          Dodaj dostawcę
        </d-button>
      </d-col>
    </d-row>

    <d-row
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="supplier-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj imię, nazwisko lub e-mail użytkownika"
          v-model="filters.search" />
        <v-select
          style="width: 360px;"
          class="ml-2"
          :options="statusType"
          v-model="filters.active"
          placeholder="Status konta"
          :searchable="false"
          label="text">
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">ID</th>
            <th
              scope="col"
              class="border-0">Imię i Nazwisko</th>
            <th
              scope="col"
              class="border-0">Adres e-mail</th>
            <th
              scope="col"
              class="border-0">Aktywny</th>
            <th
              scope="col"
              class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded && suppliers">
          <tr
            v-for="(supplier, index) of suppliers"
            :key="'user-' + index">
            <td class="align-middle">
              {{ supplier.id }}
            </td>
            <td class="align-middle">
              {{ supplier.name }}
            </td>
            <td class="align-middle">
              {{ supplier.email }}
            </td>
            <td class="align-middle">
              <d-badge
                style="width: 5rem"
                :theme="'primary'"
                v-if="supplier.active === 1">Tak</d-badge>
              <d-badge
                style="width: 5rem"
                :theme="'secondary'"
                v-if="supplier.active !== 1">Nie</d-badge>
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/dostawcy/edycja/' + supplier.id)"
                class="mr-2 action-button"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                class="action-button"
                theme="danger"
                @click.native="removeUser(supplier.id)"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="suppliers.length === 0">
            <td
              colspan="5"
              class="text-center">
              Brak dostawców do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded || !suppliers"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage"/>
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'administrators',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data () {
    return {
      suppliers: [],
      loaded: false,
      load_error: false,
      remove_in_progress: false,
      filters: {
        search: '',
        active: ''
      }
    };
  },
  computed: {
    statusType () {
      return [
        {
          text: 'Tak',
          value: 1
        },
        {
          text: 'Nie',
          value: 0
        },
      ];
    }
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search
      };
      if (this.filters.active.value === 1 || this.filters.active.value === 0) {
        where.active = this.filters.active.value;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/suppliers/items?page=' + this.currentPage,
        listField: 'suppliers',
        errorKey: 'load_error',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.load_error = false;
      this.filters = {
        search: '',
        active: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['supplier-filters-form'], this.debouncedLoadFilteredData);
    },
    removeUser (suppliersID) {
      this.remove_in_progress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/suppliers/delete/',
        id: suppliersID,
        successTitle: 'Usunięto dostawcę',
        successText: 'Wybrany dostawca został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć tego dostawcę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie dostawcy nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.remove_in_progress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.remove_in_progress = false;
        }
      });
    }
  }
};
</script>

